<template>
  <main id="main" @click="closeAllDropdowns">
    <header style="height: 45vh"
            class="bg_light_theme w-100 rounded_div position-relative d-flex justify-content-center align-items-center overflow-hidden">
        <img src="@/assets/imgs/ayendaman-pic-1.png" class="logo slideInUp" alt="">
    </header>

    <div class="p-3 d-flex flex-column align-items-center row-gap-5 mt-5">
        <h1 class="text-center font_larger bold fadeIn">{{ t('register_app') }}</h1>

        <div class="w-100 d-flex align-items-center justify-content-between gap-3">
            <div class="w-50">
                <label class="pe-3 fadeIn" for="name">{{ t('name') }}</label>
                <input v-model="form.name" class="p-4 w-100 rounded-pill" id="name" type="text">
            </div>
            <div class="w-50">
                <label class="pe-3 fadeIn" for="takh">{{ t('family') }}</label>
                <input v-model="form.family" class="p-4 w-100 rounded-pill" id="takh" type="text">
            </div>
        </div>

        <div class="w-100 d-flex align-items-center justify-content-between gap-3">
            <div class="w-50">
                <label class="pe-3 fadeIn" for="father_name">{{ t('father_name') }}</label>
                <input v-model="form.father_name" class="p-4 w-100 rounded-pill" id="father_name" type="text">
            </div>
            <div class="w-50">
                <label class="pe-3 fadeIn" for="takh_father">{{ t('father_family') }}</label>
                <input v-model="form.father_family" class="p-4 w-100 rounded-pill" id="takh_father" type="text">
            </div>
        </div>

        <div class="w-100 d-flex align-items-center justify-content-between gap-3">
            <div class="w-50 position-relative z-index-dropdown">
                <label class="pe-3 fadeIn">{{ t('country') }}</label>
                
                <div class="custom-select-box p-4 w-100 rounded-pill d-flex align-items-center justify-content-between cursor-pointer bg-white" 
                     @click.stop="toggleCountryList">
                    <div class="d-flex align-items-center gap-2 overflow-hidden">
                        <img v-if="selectedCountryFlag" :src="selectedCountryFlag" class="flag-icon" alt="">
                        <span class="text-truncate">{{ form.country || t('click_to_select') }}</span>
                    </div>
                    <img src="@/assets/imgs/back.svg" class="rotate-icon" :class="{ 'open': countryListOpen }" style="width: 10px; transform: rotate(-90deg);" alt="">
                </div>

                <ul v-if="countryListOpen" class="custom-options-list rounded-4 shadow_box bg-white position-absolute w-100 p-0 m-0 list-unstyled">
                    <li v-for="country in countries" :key="country.id" 
                        class="p-3 border-bottom d-flex align-items-center gap-2 hover-bg"
                        @click.stop="selectCountry(country)">
                        <img :src="country.pic" class="flag-icon" alt="">
                        <span>{{ country.title }}</span>
                    </li>
                </ul>
            </div>

            <div class="w-50">
                <label class="pe-3 fadeIn" for="age">{{ t('age') }}</label>
                <input v-model="form.age" class="p-4 w-100 rounded-pill" id="age" type="number">
            </div>
        </div>

        <div class="w-100 d-flex flex-column align-items-center position-relative z-index-dropdown-low">
            <label class="pe-3 fadeIn w-100 text-start">{{ t('degree') }}</label>
            
             <div class="custom-select-box p-4 w-100 rounded-pill d-flex align-items-center justify-content-between cursor-pointer bg-white" 
                 @click.stop="toggleDegreeList">
                <span>{{ form.degree || t('click_to_select') }}</span>
                <img src="@/assets/imgs/back.svg" class="rotate-icon" :class="{ 'open': degreeListOpen }" style="width: 10px; transform: rotate(-90deg);" alt="">
            </div>

            <ul v-if="degreeListOpen" class="custom-options-list rounded-4 shadow_box bg-white position-absolute w-100 p-0 m-0 list-unstyled" style="top: 85px;">
                <li v-for="deg in degrees" :key="deg" 
                    class="p-3 border-bottom text-center hover-bg"
                    @click.stop="selectDegree(deg)">
                    {{ deg }}
                </li>
            </ul>
        </div>

        <div class="w-100 fadeIn text-center">
            <label class="pe-3 w-100 text-end mb-2">{{ t('upload_image') }}</label>
            
            <div class="d-flex justify-content-between gap-2">
                
                <div class="upload-box" @click="triggerUpload(1)">
                    <div v-if="docs[1].loading" class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">...</span>
                    </div>
                    <div v-else-if="docs[1].name" class="d-flex flex-column align-items-center">
                        <img src="@/assets/imgs/tick.svg" class="icon-size-2" alt="Uploaded">
                        <span class="font_small text-success mt-1">{{ t('successful_submit') }}</span>
                    </div>
                    <div v-else class="d-flex flex-column align-items-center text-color_gray">
                        <span class="font_large bold">+</span>
                        <span class="font_small text_color_blue">{{ t('upload_mandatory') }}</span>
                    </div>
                </div>

                <div class="upload-box" @click="triggerUpload(2)">
                    <div v-if="docs[2].loading" class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">...</span>
                    </div>
                    <div v-else-if="docs[2].name" class="d-flex flex-column align-items-center">
                        <img src="@/assets/imgs/tick.svg" class="icon-size-2" alt="Uploaded">
                        <span class="font_small text-success mt-1">{{ t('successful_submit') }}</span>
                    </div>
                    <div v-else class="d-flex flex-column align-items-center text-color_gray">
                        <span class="font_large bold">+</span>
                        <span class="font_small">{{ t('optional') }}</span>
                    </div>
                </div>

                <div class="upload-box" @click="triggerUpload(3)">
                    <div v-if="docs[3].loading" class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">...</span>
                    </div>
                    <div v-else-if="docs[3].name" class="d-flex flex-column align-items-center">
                        <img src="@/assets/imgs/tick.svg" class="icon-size-2" alt="Uploaded">
                        <span class="font_small text-success mt-1">{{ t('successful_submit') }}</span>
                    </div>
                    <div v-else class="d-flex flex-column align-items-center text-color_gray">
                        <span class="font_large bold">+</span>
                        <span class="font_small">{{ t('optional') }}</span>
                    </div>
                </div>

            </div>

            <input type="file" ref="file1" @change="(e) => handleUpload(e, 1)" accept="image/*" style="display: none;">
            <input type="file" ref="file2" @change="(e) => handleUpload(e, 2)" accept="image/*" style="display: none;">
            <input type="file" ref="file3" @change="(e) => handleUpload(e, 3)" accept="image/*" style="display: none;">
        </div>

        <button class="button" @click="validateAndSubmit" :disabled="isLoadingAny" :style="isLoadingAny ? 'opacity: 0.7' : ''">
            {{ loading ? t('loading') : t('submit_post') }}
        </button>
    </div>

    <img src="@/assets/imgs/whatsapp.svg" class="icon-size-8 position-absolute slideInUp bottom-3 start-5" alt="">

    <div v-if="showErrorModal" class="modal_overlay" @click.self="showErrorModal = false">
      <div class="modal_content bg_white rounded-4 p-4 shadow_box text-center">
        <p class="bold mb-4">
            {{ t('fill_required') }} <span class="text-danger">({{ missingFieldName }})</span>
        </p>
        <button class="button w-50 py-2 font_small" @click="showErrorModal = false">{{ t('understand') }}</button>
      </div>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'

export default {
  name: 'TeacherRegisterView',
  data() {
    return {
      form: {
        name: '',
        family: '',
        father_name: '',
        father_family: '',
        country: null,
        age: '',
        degree: null,
      },
      docs: {
        1: { name: '', loading: false },
        2: { name: '', loading: false },
        3: { name: '', loading: false }
      },
      countries: [],
      degrees: ['بکلوریا', 'فارغ صنف ۱۴', 'لسانس', 'ماستری', 'داکتر'],
      loading: false,
      showErrorModal: false,
      missingFieldName: '',
      countryListOpen: false,
      degreeListOpen: false
    }
  },
  computed: {
    selectedCountryFlag() {
      if (!this.form.country || !this.countries.length) return null;
      const countryObj = this.countries.find(c => c.title === this.form.country);
      return countryObj ? countryObj.pic : null;
    },
    isLoadingAny() {
        return this.loading || this.docs[1].loading || this.docs[2].loading || this.docs[3].loading;
    }
  },
  methods: {
    async fetchCountries() {
      try {
        const formData = createFormData({ action: 'country' })
        const response = await apiClient.post('/public_info', formData)
        
        if (response.data && Array.isArray(response.data)) {
          this.countries = response.data
        }
      } catch (error) {
        console.error('Error fetching countries:', error)
      }
    },
    triggerUpload(index) {
        if (!this.docs[index].loading) {
            this.$refs[`file${index}`].click();
        }
    },
    async uploadFile(file) {
      const formData = new FormData();
      formData.append('pic', file);
      formData.append('apikey', '4f3d2a9b7c1e5d6f8a0b9c3d2e4f6a7b');

      try {
        const res = await apiClient.post('/upload_pic', formData);
        if (res.data.status === 'ok') {
          return res.data.pic_name;
        } else {
          this.notify(this.t('upload_error'), 'error');
          return null;
        }
      } catch (e) {
        this.notify(this.t('upload_error'), 'error');
        return null;
      }
    },
    async handleUpload(event, index) {
        const file = event.target.files[0];
        if (file) {
            this.docs[index].loading = true;
            const fileName = await this.uploadFile(file);
            if (fileName) {
                this.docs[index].name = fileName;
            }
            this.docs[index].loading = false;
        }
    },
    toggleCountryList() {
        this.countryListOpen = !this.countryListOpen;
        this.degreeListOpen = false;
    },
    selectCountry(country) {
        this.form.country = country.title;
        this.countryListOpen = false;
    },
    toggleDegreeList() {
        this.degreeListOpen = !this.degreeListOpen;
        this.countryListOpen = false;
    },
    selectDegree(deg) {
        this.form.degree = deg;
        this.degreeListOpen = false;
    },
    closeAllDropdowns() {
        this.countryListOpen = false;
        this.degreeListOpen = false;
    },
    validateAndSubmit() {
      const fields = [
        { key: 'name', label: this.t('name'), val: this.form.name },
        { key: 'family', label: this.t('family'), val: this.form.family },
        { key: 'father_name', label: this.t('father_name'), val: this.form.father_name },
        { key: 'father_family', label: this.t('father_family'), val: this.form.father_family },
        { key: 'country', label: this.t('country'), val: this.form.country },
        { key: 'age', label: this.t('age'), val: this.form.age },
        { key: 'degree', label: this.t('degree'), val: this.form.degree },
        { key: 'pic1', label: this.t('job_docs'), val: this.docs[1].name }
      ]

      for (const field of fields) {
        if (!field.val) {
          this.missingFieldName = field.label
          this.showErrorModal = true
          return
        }
      }

      this.registerUser()
    },
    async registerUser() {
      this.loading = true
      const email = localStorage.getItem('user_email')
      
      if (!email) {
          this.notify(this.t('login_email_title'), 'error')
          this.$router.push({ name: 'TeacherLogin' })
          return
      }

      try {
        const data = {
          name: this.form.name,
          family: this.form.family,
          father_name: this.form.father_name,
          father_family: this.form.father_family,
          country: this.form.country,
          age: this.form.age,
          degree: this.form.degree,
          email: email,
          pic1: this.docs[1].name,
          pic2: this.docs[2].name,
          pic3: this.docs[3].name,
          language: localStorage.getItem('app_lang') || 'fa'
        }

        const formData = createFormData(data)
        const response = await apiClient.post('/teacher/signup', formData)

        if (response.data.status === 'ok' || response.data.event === 'signup_success') {
           const userId = response.data.data?.user_id || response.data.user_id
           if (userId) {
               localStorage.setItem('user_id', userId)
           }
           this.$router.push({ name: 'TeacherHome' })
        } else {
           this.notify(response.data.message || this.t('error_submit'), 'error')
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          this.notify(error.response.data.message, 'error')
        } else {
          this.notify(this.t('connection_error'), 'error')
        }
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    this.fetchCountries()
  }
}
</script>

<style scoped>
.rounded_div {
    border-radius: 0 0 5rem 5rem;
    -webkit-box-shadow: 3px 10px 13px -2px rgba(153, 182, 254, 0.68);
    box-shadow: 3px 10px 13px -2px rgba(153, 182, 254, 0.68);
}
.logo {
    width: 25rem;
}
.modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal_content {
  width: 85%;
  max-width: 25rem;
  animation: fadeIn 0.3s ease-out;
}
.text-danger {
    color: #dc3545;
}
@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}
.custom-select-box {
    border: 1px solid #e1e1e1;
    transition: all 0.3s ease;
}
.cursor-pointer {
    cursor: pointer;
}
.flag-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
    border-radius: 50%;
}
.custom-options-list {
    top: 100%;
    left: 0;
    max-height: 200px;
    overflow-y: auto;
    z-index: 100;
    margin-top: 5px !important;
}
.hover-bg {
    transition: background-color 0.2s;
    cursor: pointer;
}
.hover-bg:hover {
    background-color: #f8f9fa;
}
.rotate-icon {
    transition: transform 0.3s ease;
}
.rotate-icon.open {
    transform: rotate(90deg) !important;
}
.z-index-dropdown {
    z-index: 20;
}
.z-index-dropdown-low {
    z-index: 10;
}
.upload-box {
    width: 32%;
    height: 8rem;
    border: 2px dashed #ccc;
    border-radius: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: #fff;
    transition: all 0.3s;
}
.upload-box:active {
    background-color: #f0f0f0;
    border-color: #4A00E0;
}
.text_color_blue {
    color: #4A00E0;
}
</style>